import { SET_SEARCH_BAR_KEYWORD } from './actionTypes';

export function setSearchBarKeyword(keyword) {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_BAR_KEYWORD, keyword });
    };
}
